import React from "react";
import Circle from "files/circle.svg";
const FilterConditionCard = props => (
  <div className="row px-4">
    <div className="col-md-4 stretch-card grid-margin">
      <div className="card bg-gradient-white card-img-holder ">
        <div className="card-body">
          <img src={Circle} className="card-img-absolute" alt="circle-image" />
          <h4 className="font-weight-normal mb-3">
            Total Readings Found (
            {props.currentState.readingTypeValue.description})
            <i className="mdi mdi-chart-line mdi-24px float-right" />
          </h4>
          <h1 className="mb-4 mt-5 text-center">{props.totalReadings}</h1>
          <h6 className="card-text"> </h6>
        </div>
      </div>
    </div>
    <div className="col-md-4 stretch-card grid-margin">
      <div className="card bg-success card-img-holder text-white">
        <div className="card-body">
          {/* <img src={Circle} className="card-img-absolute" alt="circle-image" /> */}
          <h4 className="font-weight-normal mb-3">
            Total Condition Found by Condition Picked
            <i className="mdi mdi-bookmark-outline mdi-24px float-right" />
          </h4>
          <h1 className="mb-4 mt-5 text-center">{props.countExceptions}</h1>
          {/* <h6 className="card-text">
            <button className="btn btn-info btn-block">VIEW DETAILS</button>
          </h6> */}
        </div>
      </div>
    </div>
    <div className="col-md-4 stretch-card grid-margin">
      <div className="card bg-gradient-white card-img-holder ">
        <div className="card-body">
          <img src={Circle} className="card-img-absolute" alt="circle-image" />
          <h4 className="font-weight-normal mb-3">
            Percent
            <i className="mdi mdi-bookmark-outline mdi-24px float-right" />
          </h4>
          <h1 className="mb-4 mt-5 text-center">{props.average || 0} %</h1>
        </div>
      </div>
    </div>
  </div>
);

export default FilterConditionCard;
